<div *ngIf="!displayMobileView" class="content-table-pointer">
  <ion-row class="content" routerLink="/app/users/edit/{{ row.id }}">
    <ion-col size="1">
      <ion-item class="input" lines="none" color="transparent">
        <app-avatar [user]="row"> </app-avatar>
      </ion-item>
    </ion-col>

    <ion-col size="2">
      <ion-item class="input" lines="none" color="transparent">
        <ion-label class="word-break-always">{{ row.firstName }}</ion-label>
      </ion-item>
    </ion-col>

    <ion-col size="2">
      <ion-item class="input" lines="none" color="transparent">
        <ion-label class="word-break-always">{{ row.lastName }}</ion-label>
      </ion-item>
    </ion-col>

    <ion-col size="2">
      <ion-item
        class="inpFut"
        lines="none"
        color="transparent"
        *ngIf="row.idCompany"
      >
        <ion-label>
          {{ companyService.getCompanyName(row.idCompany) }}
        </ion-label>
      </ion-item>
    </ion-col>

    <ion-col size="3">
      <ion-item class="input" lines="none" color="transparent">
        <ion-label class="word-break-always">{{ row.email }}</ion-label>
      </ion-item>
    </ion-col>

    <ion-col size="2">
      <ion-item class="input" lines="none" color="transparent">
        <ion-label>{{ row.mobilePhone }}</ion-label>
      </ion-item>
    </ion-col>
  </ion-row>
</div>

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder"
  routerLink="/app/users/edit/{{ row.id }}"
>
  <ion-card-content class="invitation-mobile-header">
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col size="9">
          <div class="block margin-left">
            <ion-text class="name"
              >{{ row.firstName }} {{ row.lastName }}</ion-text
            >
            <ion-card-subtitle>
              {{ row.company?.name }}
            </ion-card-subtitle>
          </div>
        </ion-col>
        <ion-col size="3" class="flex-justify-content-flex-end">
          <ion-avatar class="mobile-avatar">
            <ion-label *ngIf="!row.avatar">
              {{ row.firstName === "SuperAdmin" ? "SA" : row.firstName[0]
              }}{{ row.lastName ? row.lastName[0] : "" }}
            </ion-label>

            <img *ngIf="row.avatar" [src]="
                row.avatar.thumbnail
                  ? row.avatar.thumbnail
                  : row.avatar.filePath
              " />
          </ion-avatar>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider"></div>
  </ion-card-content>

  <ion-card-content>
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col size="12" size-md="6" size-sm="6" size-lg="6" size-xl="6">
          <ion-item lines="none" class="item">
            <ion-img
              class="icon icon-margin"
              src="../../../assets/icons/email.svg"
            ></ion-img>
            <ion-text class="inv-info">{{ row.email }}</ion-text>
          </ion-item>
        </ion-col>
        <ion-col size="12" size-md="6" size-sm="6" size-lg="6" size-xl="6">
          <!-- <ion-icon
            name="call-outline"
            class="icon-margin"
          ></ion-icon -->
          <ion-item lines="none">
            <ion-img
              class="icon icon-margin"
              src="../../../assets/icons/phone.svg"
            ></ion-img>
            <ion-text class="inv-info">{{ row.mobilePhone || "-" }}</ion-text>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
